// userPreference
const userPreferences = () => import(/* webpackChunkName: "dashboard" */ 'Features/userPreferences/Main.vue');

const userPreferencesRoute =  {
  name: 'userPreferences',
  path: 'userPreferences',
  component: userPreferences,
  meta: {
    requiresAuth: true,
    title: 'message.userPreferences',
    breadcrumb: 'message.userPreferences',

    showDateRangeFilter: false
  }
}

export const UserPreferencesRoute = userPreferencesRoute;